export default __webpack_public_path__ + "static/media/RightArrow.bd99daa2.svg";